import {
  CheckCircleOutlined,
  ReportOutlined,
  SvgIconComponent,
  WarningAmberOutlined,
} from '@mui/icons-material';

import { GraphDocStatus, SvgIconStatus } from '../Types/enums';

// Rendering / computation thresholds (keep UI responsive on large graphs)
export const CENTRALITY_MAX_NODES = 3500;
export const LOUVAIN_MAX_NODES = 12000;

export const NODE_FADE_COLOR = '#bbb';
export const EDGE_FADE_COLOR = '#eee';

export const CLUSTER_COLORS = [
  '#e6194b',
  '#3cb44b',
  '#ffe119',
  '#4363d8',
  '#f58231',
  '#911eb4',
  '#46f0f0',
  '#f032e6',
  '#bcf60c',
  '#fabebe',
  '#008080',
  '#e6beff',
  '#9a6324',
  '#fffac8',
  '#800000',
  '#aaffc3',
  '#808000',
  '#ffd8b1',
  '#000075',
  '#808080',
];

export type GraphDocStatusConfig = {
  icon: SvgIconComponent;
  color: 'success' | 'warning' | 'error';
  tooltip: string;
};

export const GRAPH_DOC_STATUS_CONFIG: Record<GraphDocStatus, GraphDocStatusConfig> = {
  [GraphDocStatus.COMPLETED]: {
    icon: CheckCircleOutlined,
    color: SvgIconStatus.SUCCESS,
    tooltip: 'Mapped: Graph extraction completed successfully.',
  },

  [GraphDocStatus.PROCESSING]: {
    icon: WarningAmberOutlined,
    color: SvgIconStatus.WARNING,
    tooltip: 'Mapping in progress: Graph extraction is still running.',
  },

  [GraphDocStatus.FAILED]: {
    icon: ReportOutlined,
    color: SvgIconStatus.ERROR,
    tooltip: 'Mapping failed: Graph extraction did not complete.',
  },

  [GraphDocStatus.PENDING]: {
    icon: WarningAmberOutlined,
    color: SvgIconStatus.WARNING,
    tooltip: 'Mapping status Pending.',
  },
};

export const hasDocument = (docs: unknown, documentId?: string): boolean => {
  if (!documentId) return true;
  if (!Array.isArray(docs)) return false;

  const docIdAsNumber = Number(documentId);
  const hasNumericDocId = Number.isFinite(docIdAsNumber);

  for (let i = 0; i < docs.length; i++) {
    const value = docs[i];

    if (value === documentId) return true;
    if (hasNumericDocId && value === docIdAsNumber) return true;
  }

  return false;
};
